__turbopack_context__.v({
  "bounce": "wordle-module__5oUupW__bounce",
  "fadeIn": "wordle-module__5oUupW__fadeIn",
  "flip": "wordle-module__5oUupW__flip",
  "pop": "wordle-module__5oUupW__pop",
  "shake": "wordle-module__5oUupW__shake",
});
